/* import __COLOCATED_TEMPLATE__ from './pagination-controls.hbs'; */
var _dec, _dec2, _dec3, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { action, computed, set } from '@ember/object';
import { NEXT_PAGE_SIZE } from '@banking/api/services/banking-unit-account-pagination';
let PaginationControls = (_dec = computed('units.length'), _dec2 = computed('currentPage', 'numberOfPages', 'bankingUnitAccountPagination.isLoading'), _dec3 = computed('currentPage', 'numberOfPages'), _class = class PaginationControls extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "bankingUnitAccountPagination", _descriptor, this);
    _defineProperty(this, "units", void 0);
    _defineProperty(this, "balances", void 0);
    _defineProperty(this, "pageStart", void 0);
    _defineProperty(this, "pageEnd", void 0);
    _defineProperty(this, "currentPage", 1);
  }
  get numberOfPages() {
    return Math.ceil(this.units?.length / NEXT_PAGE_SIZE);
  }

  // Do not allow them to spam click right while loading, otherwise it will send multiple requests
  get canGoRight() {
    return this.currentPage < this.numberOfPages && !this.bankingUnitAccountPagination.isLoading;
  }
  get canGoLeft() {
    return this.currentPage > 1;
  }
  async goRight() {
    if (!this.canGoRight) {
      return;
    }
    set(this, 'currentPage', this.currentPage + 1);
    const nextPageStart = (this.currentPage - 1) * NEXT_PAGE_SIZE;
    set(this, 'pageStart', nextPageStart);
    set(this, 'pageEnd', nextPageStart + NEXT_PAGE_SIZE);

    // If we are trying to view balances that are currently not loaded, load them
    if (this.pageStart > this.balances.length - 1) {
      await this.bankingUnitAccountPagination.getNextPage();
    }
  }
  goLeft() {
    if (!this.canGoLeft) {
      return;
    }
    set(this, 'currentPage', this.currentPage - 1);
    const previousPageStart = (this.currentPage - 1) * NEXT_PAGE_SIZE;
    set(this, 'pageStart', previousPageStart);
    set(this, 'pageEnd', previousPageStart + NEXT_PAGE_SIZE);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "bankingUnitAccountPagination", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "numberOfPages", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "numberOfPages"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canGoRight", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "canGoRight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canGoLeft", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "canGoLeft"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goRight", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goRight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goLeft", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goLeft"), _class.prototype), _class);
export { PaginationControls as default };